import React, { Component } from "react";
import {
  Check,
  ChevronRight,
  Copy,
  Edit,
  Plus,
  Search,
  Trash,
  X,
} from "react-feather";
import { UTMService, getCharacters } from "../../../api/rest-apis";
import {
  extractPromptsFromGrouped,
  groupByForPlan,
} from "../../../helpers/utm";
import { toastHelper } from "../../../helpers/toast";
import AdminHeader from "../components/header";
import Spin from "../../../helpers/spin";

import { ChevronDown, ChevronUp } from "react-feather";

interface PostSignup {
  label: string;
  prompt: string;
}

interface CharacterWithLinks {
  utmConfigCount?: number;
  latestLink?: string;
  _id?: string;
  character_name?: string;
}

interface State {
  _id?: string;
  character: string;
  characters: any;
  prompts: string[];
  utmSource: string;
  utmMedium: string;
  utmCampaign: string;
  utmTerm: string;
  utmContent: string;
  popupText: string;
  generatedLinks: Record<string, string[]>;
  generatedLink: string;
  postSignups: PostSignup[];
  preSignupPrompt: string;
  charactersWithLinks: CharacterWithLinks[];
  currentConfigId: string | null;
  isCopied: boolean;
  loading: boolean;
  deletingLinkId: string | null;
  bookTalkMode: boolean;
  loadingPage: boolean;
  activeLink: number;

  expandedRows: Record<string, boolean>;
  pageIndex: number;
  pageSize: number;
  sorting: { column: any; direction: "asc" | "desc" };
  searchTerm: string;

  tableShow: boolean;
}

type UTMParams = Pick<
  State,
  | "character"
  | "utmSource"
  | "utmMedium"
  | "utmCampaign"
  | "utmTerm"
  | "utmContent"
>;
type StateKeys = keyof Omit<State, "postSignups" | "generatedLink">;
type UTMParamsT = Pick<
  State,
  "utmSource" | "utmMedium" | "utmCampaign" | "utmTerm" | "utmContent"
>;

class UTMForm extends Component<{}, State> {
  state: State = {
    character: "",
    characters: [],
    bookTalkMode: false,
    charactersWithLinks: [],
    prompts: [],
    utmSource: "",
    utmMedium: "",
    utmCampaign: "",
    utmTerm: "",
    utmContent: "",
    generatedLink: "",
    generatedLinks: {},
    postSignups: [],
    popupText: "",
    preSignupPrompt: "",

    currentConfigId: null,
    isCopied: false,
    loading: false,
    deletingLinkId: null,
    loadingPage: true,
    activeLink: -1,

    expandedRows: {},
    pageIndex: 0,
    pageSize: 5,
    sorting: { column: "createdAt", direction: "desc" },
    searchTerm: "",

    tableShow: true,
  };

  async componentDidMount() {
    try {
      this.fetchCharactersWithLinks();
      // this.loadCharacterConfigs();
      const result: any = await getCharacters();

      const characters = result.characters;

      this.setState({
        characters,
        character: characters[0]._id,
        popupText: "",
        preSignupPrompt: "",
      });

      this.setState({ prompts: this.extractAndReformat(result.characters[0]) });
    } catch (error) {
      console.error(error);
    } finally {
      this.setState({ loadingPage: false });
    }
  }

  extractAndReformat = (firstChar: any, separate: boolean = false) => {
    const firstCharAssistants = firstChar.assistants || [];
    const bookTalkAssistants = firstChar.book_talk_assistants || [];

    // 1) Group each array by for_plan
    const groupedAssistant = groupByForPlan(firstCharAssistants);
    const groupedBookTalk = groupByForPlan(bookTalkAssistants);

    // 2) Extract prompts with the correct prefixes
    const assistantPrompts: any = extractPromptsFromGrouped(
      groupedAssistant,
      "Personality"
    );
    const bookTalkPrompts: any = extractPromptsFromGrouped(
      groupedBookTalk,
      "Book Talk"
    );

    // 3) Combine into a single array
    const allPrompts: any = [].concat(assistantPrompts).concat(bookTalkPrompts);
    if (separate) {
      return { assistantPrompts, bookTalkPrompts };
    }
    return allPrompts;
  };

  componentDidUpdate(prevProps: Readonly<{}>, prevState: Readonly<State>) {
    const utmParamsChanged = (
      [
        "utmSource",
        "utmMedium",
        "utmCampaign",
        "utmTerm",
        "utmContent",
        "bookTalkMode",
      ] as (keyof State)[]
    ).some((param) => this.state[param] !== prevState[param]);

    const postSignupsChanged =
      JSON.stringify(this.state.postSignups) !==
      JSON.stringify(prevState.postSignups);

    if (utmParamsChanged || postSignupsChanged) {
      this.generateUTMLink();
    }

    if (prevState.character != this.state.character) {
      //this.loadCharacterConfigs();
    }
  }

  // Add URL generation method
  generateUTMLink = () => {
    const baseUrl = window.location.protocol + "//" + window.location.host;
    const {
      utmSource,
      utmMedium,
      utmCampaign,
      utmTerm,
      utmContent,
      bookTalkMode,
    } = this.state;

    const params: Record<string, string> = {};

    if (utmSource) params.utm_source = utmSource.toLowerCase();
    if (utmMedium) params.utm_medium = utmMedium.toLowerCase();
    if (utmCampaign) params.utm_campaign = utmCampaign.toLowerCase();
    if (utmTerm) params.utm_term = utmTerm.toLowerCase();
    if (utmContent) params.utm_content = utmContent.toLowerCase();

    params.bookTalk = bookTalkMode ? "true" : "false";

    const queryString = new URLSearchParams(params).toString();
    const newLink = queryString ? `${baseUrl}?${queryString}` : baseUrl;

    this.setState({ generatedLink: newLink }, () => {
      if (this.state.currentConfigId) {
        this.addGeneratedLink();
      }
    });
  };

  // Update the handleChange method
  handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement
    >
  ) => {
    const { name, value } = e.target;
    console.log(name, value);

    if (name.startsWith("postSignupLabel")) {
      const index = parseInt(name.split("_")[1]);
      this.setState((prev) => {
        const postSignups = [...prev.postSignups];
        postSignups[index].label = value;
        return { postSignups };
      });
    } else if (this.isUTMParam(name) || "popupText") {
      this.setState({ [name]: value } as Pick<UTMParams, keyof UTMParams>);
    }

    if (name == "character") {
      setTimeout(async () => {
        //this.loadCharacterConfigs();
        try {
          const character = this.state.characters.find(
            (char: any) => char._id == value
          );

          if (character) {
            this.setState({ prompts: this.extractAndReformat(character) });
          }
        } catch (error) {}
      }, 500);
    }
  };

  handlePromptChange = (index: number, value: string) => {
    const currentCharacter = this.state.characters.find(
      (character: any) => character._id === this.state.character
    );

    if (currentCharacter) {
      const response = this.extractAndReformat(currentCharacter, true);

      // Check if the selected value exists in bookTalkPrompts

      const isBookTalk = response.bookTalkPrompts.find(
        (prompt: any) => prompt === value // Compare with prompt.text
      );

      this.setState({ bookTalkMode: isBookTalk ? true : false });
    }
    this.setState((prev) => {
      const postSignups = [...prev.postSignups];
      postSignups[index].prompt = value;
      return { postSignups };
    });
  };

  isUTMParam = (key: string): key is keyof UTMParams => {
    const utmKeys: (keyof UTMParams)[] = [
      "utmSource",
      "utmMedium",
      "utmCampaign",
      "utmTerm",
      "utmContent",
    ];
    return utmKeys.includes(key as keyof UTMParams);
  };

  // Add this type guard function
  isStateKey = (key: string): key is StateKeys => {
    const stateKeys: StateKeys[] = [
      "character",
      "utmSource",
      "utmMedium",
      "utmCampaign",
      "utmTerm",
      "utmContent",
    ];
    return stateKeys.includes(key as StateKeys);
  };

  addPostSignup = () => {
    this.setState((prev) => ({
      postSignups: [
        ...prev.postSignups,
        { label: "", prompt: this.state.prompts[0] },
      ],
    }));
  };

  removePostSignup = (index: number) => {
    this.setState((prev) => ({
      postSignups: prev.postSignups.filter((_, i) => i !== index),
    }));
  };
  generateLink = async () => {
    this.setState({ loading: true });
    const {
      _id,
      character,
      utmSource,
      utmMedium,
      utmCampaign,
      utmTerm,
      utmContent,
      postSignups,
      popupText,
      preSignupPrompt,
    } = this.state;

    try {
      const configData = {
        character,
        utmSource,
        utmMedium,
        utmCampaign,
        utmTerm,
        utmContent,
        postSignups,
        popupText,
        preSignupPrompt,
      };

      let updatedConfig: any;

      if (_id) {
        // Update existing configuration
        updatedConfig = await UTMService.updateUTMConfig(_id, configData);
      } else {
        // Create new configuration
        updatedConfig = await UTMService.createUTMConfig(configData);
      }

      this.setState({
        _id: updatedConfig._id,
      });
      toastHelper.success("Successfully saved!");
      this.generateUTMLink();
      this.fetchCharactersWithLinks();
    } catch (error) {
      console.error("Link generation failed:", error);
    } finally {
      this.setState({ loading: false });
    }
  };

  selectCharacter = async (character: any, activeLink: number) => {
    this.setState({ loadingPage: true });

    try {
      this.setState({
        character: character.character,
        _id: character._id,
        activeLink,
        tableShow: false,
      });
      const delay = (ms: number) =>
        new Promise((resolve) => setTimeout(resolve, ms));

      await delay(500);
      this.loadCharacterConfigs(character.char);
    } catch (error) {
    } finally {
      this.setState({ loadingPage: false });
    }
  };

  loadCharacterConfigs = async (character_id = this.state.character) => {
    const { _id } = this.state;

    try {
      const configs: any = await UTMService.getConfigsByCharacter(_id as any);

      this.setState({ ...configs });
      console.log(character_id);

      const prompts = this.extractAndReformat(
        this.state.characters.find((char: any) => char._id === character_id)
      );
      this.setState({
        prompts,
      });

      setTimeout(() => {
        const response = this.extractAndReformat(
          this.state.characters.find((char: any) => char._id === character_id),
          true
        );
        const isBookTalk = response.bookTalkPrompts.find(
          (prompt: any) => prompt === this.state.postSignups[0].prompt
        );

        this.setState({ bookTalkMode: isBookTalk });
        this.generateUTMLink();
      }, 500);

      setTimeout(() => console.log(this.state), 1000);
    } catch (error) {
      console.error("Failed to load configurations:", error);
      this.setState({
        utmSource: "",
        utmMedium: "",
        utmCampaign: "",
        utmTerm: "",
        utmContent: "",
        generatedLink: "",
        generatedLinks: {},
        postSignups: [
          {
            label: "",
            prompt: this.state.prompts.length > 0 ? this.state.prompts[0] : "",
          },
        ],
        popupText: "",
        preSignupPrompt: "",
      });
    }
  };

  fetchCharactersWithLinks = async () => {
    try {
      const characters: any = await UTMService.getCharactersWithLinks();
      this.setState({ charactersWithLinks: characters });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  handleCharacterSelect = async (character: string) => {
    this.setState({ character }, this.loadCharacterConfigs);
  };

  addGeneratedLink = async () => {
    const { currentConfigId, generatedLink } = this.state;

    if (currentConfigId && generatedLink) {
      try {
        const updatedConfig = await UTMService.addGeneratedLink(
          currentConfigId,
          generatedLink
        );

        this.setState((prev: any) => ({
          ...prev.configurations.map((config: any) =>
            config._id === currentConfigId ? updatedConfig : config
          ),
        }));
      } catch (error) {
        console.error("Failed to save link:", error);
      }
    }
  };

  // Add copy handler method
  handleCopy = () => {
    navigator.clipboard.writeText(this.state.generatedLink);
    this.setState({ isCopied: true }, () => {
      setTimeout(() => this.setState({ isCopied: false }), 2000);
    });
  };

  handleDeleteInit = (linkId: string) => {
    this.setState({ deletingLinkId: linkId });
  };

  handleDeleteConfirm = async (linkId: string) => {
    const id = toastHelper.loading("Deleting UTM link ...");
    try {
      await UTMService.deleteUTMLink(linkId);
      this.setState((prev) => ({
        deletingLinkId: null,
      }));
      toastHelper.success("UTM link have been deleted.", id);
      this.fetchCharactersWithLinks();
    } catch (error) {
      console.error("Delete failed:", error);
      this.setState({ deletingLinkId: null });
      toastHelper.error("Issue deleting UTM link.", id);
    }
  };

  handleDeleteCancel = () => {
    this.setState({ deletingLinkId: null });
  };

  resetForm = () => {
    const character = this.state.characters?.length
      ? this.state.characters[0]._id
      : "";

    this.setState({
      character,
      utmSource: "",
      utmMedium: "",
      utmCampaign: "",
      utmTerm: "",
      utmContent: "",
      postSignups: [{ label: "", prompt: this.state.prompts[0] }],
      generatedLink: "",
      currentConfigId: null,
      _id: "",
      activeLink: -1,
      popupText: "",
      tableShow: false,
    });
  };

  render() {
    if (this.state.loadingPage) {
      return (
        <div className="admin">
          <AdminHeader></AdminHeader>
          <div className="flex justify-center mt-8">
            <Spin></Spin>
          </div>
        </div>
      );
    }

    return (
      <div className="admin">
        <AdminHeader></AdminHeader>
        <div className="min-h-screen bg-white py-4 px-2 sm:py-8 sm:px-4">
          <div className="flex flex-col gap-4 min-h-screen p-2 sm:p-4">
            {this.state.tableShow ? (
              <div className="w-[90%] lg:max-h-[calc(100vh-100px)] overflow-y-auto">
                {this.renderTable()}
              </div>
            ) : (
              <div className="lg:w-[80%] m-auto bg-white rounded-lg shadow-lg p-4 sm:p-6 lg:p-8">
                {this.renderUTMForm()}
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }

  renderUTMForm() {
    const {
      generatedLink,
      generatedLinks,
      postSignups,
      character,
      utmSource,
      utmMedium,
      utmCampaign,
      utmTerm,
      utmContent,
      popupText,
      preSignupPrompt,
    } = this.state;

    // Create UTM params object for cleaner access
    const utmParams: any = {
      utmSource,
      utmMedium,
      utmCampaign,
      utmTerm,
      utmContent,
    };

    return (
      <div className="relative">
        <header className="mb-6">
          <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-4">
            <button
              onClick={() => this.setState({ tableShow: true })}
              className="absolute -top-[4rem] -right-10 bg-red-500 hover:bg-red-600 text-2xl w-10 h-10 rounded-full focus:outline-none text-white z-10"
            >
              ✗
            </button>
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
                UTM Link Generator
              </h1>
              <p className="text-gray-600 text-sm mt-1">
                Switch to previous links from the left panel
              </p>
            </div>
            <div className="flex gap-2 sm:gap-4">
              <button
                onClick={this.resetForm}
                className="bg-white border border-gray-300 text-gray-800 text-sm font-medium py-2 px-3 rounded hover:bg-gray-100"
              >
                New UTM
              </button>
              {this.state.deletingLinkId === this.state._id ? (
                <div className="flex gap-2">
                  <button
                    onClick={() =>
                      this.handleDeleteConfirm(this.state._id || "")
                    }
                    className="p-2 bg-green-600 hover:bg-green-700 text-white rounded-full"
                  >
                    <Check className="w-4 h-4 sm:w-5 sm:h-5" />
                  </button>
                  <button
                    onClick={this.handleDeleteCancel}
                    className="p-2 bg-red-600 hover:bg-red-700 text-white rounded-full"
                  >
                    <X className="w-4 h-4 sm:w-5 sm:h-5" color="#fff" />
                  </button>
                </div>
              ) : (
                <button
                  onClick={() => this.handleDeleteInit(this.state._id || "")}
                  className="p-2 bg-red-500 hover:bg-red-600 text-white rounded-full"
                >
                  <Trash className="w-4 h-4 sm:w-5 sm:h-5" color="#fff" />
                </button>
              )}
            </div>
          </div>
        </header>

        <div className="space-y-4 sm:space-y-6">
          {/* Character Section */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Character
            </label>
            <select
              name="character"
              value={this.state.character}
              onChange={this.handleChange}
              className="w-full p-2.5 sm:p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              {this.state.characters.map((char: any) => (
                <option key={char._id} value={char._id}>
                  {char.character_name}
                </option>
              ))}
            </select>
          </div>

          {/* UTM Parameters Grid */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4">
              UTM Parameters
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              {(Object.keys(utmParams) as (keyof UTMParams)[]).map(
                (key: any) => (
                  <div key={key}>
                    <label className="block text-sm font-medium text-gray-700 mb-1 capitalize">
                      {key.replace("utm", "UTM ")}
                    </label>
                    <input
                      name={key}
                      value={utmParams[key]}
                      onChange={this.handleChange}
                      className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder={`Enter ${key.replace("utm", "UTM ")}`}
                    />
                  </div>
                )
              )}
            </div>
          </div>

          {/* Pre-Signup Section */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4">
              Pre-Signup Configuration
            </h3>
            <select
              name="preSignupPrompt"
              value={preSignupPrompt}
              onChange={this.handleChange}
              className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select a prompt</option>
              {this.state.prompts.map((p: string, idx) =>
                p.startsWith("Personality –") || p.startsWith("Book Talk –") ? (
                  <option
                    key={`divider-${idx}`}
                    disabled
                    className="disabled-option-header"
                  >
                    {p}
                  </option>
                ) : (
                  <option key={`prompt-${idx}`} value={p}>
                    {p}
                  </option>
                )
              )}
            </select>
          </div>

          {/* Post-Signup Section */}
          <div>
            <h3 className="text-base sm:text-lg font-semibold text-gray-800 mb-4">
              Post-Signup Configuration
            </h3>
            <div className="space-y-3 sm:space-y-4">
              {postSignups.map((signup, index) => (
                <div
                  key={index}
                  className="flex flex-col sm:flex-row gap-3 sm:gap-4"
                >
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Label
                    </label>
                    <input
                      name={`postSignupLabel_${index}`}
                      value={signup.label}
                      onChange={this.handleChange}
                      className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      placeholder="Link text"
                    />
                  </div>
                  <div className="flex-1">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Prompt
                    </label>
                    <div className="flex gap-2">
                      <select
                        value={signup.prompt}
                        onChange={(e) =>
                          this.handlePromptChange(index, e.target.value)
                        }
                        className="w-full p-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500"
                      >
                        {this.state.prompts.map((p: string, idx) =>
                          p.startsWith("Assistant –") ||
                          p.startsWith("Book Talk –") ? (
                            <option
                              key={`divider-${idx}`}
                              disabled
                              className="disabled-option-header"
                            >
                              {p}
                            </option>
                          ) : (
                            <option key={`prompt-${idx}`} value={p}>
                              {p}
                            </option>
                          )
                        )}
                      </select>
                      {postSignups.length > 1 && (
                        <button
                          onClick={() => this.removePostSignup(index)}
                          className="p-2 text-red-600 hover:bg-red-50 rounded-lg"
                        >
                          <X size={18} />
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
              <button
                onClick={this.addPostSignup}
                className="flex items-center gap-2 text-blue-600 hover:text-blue-700 text-sm sm:text-base"
              >
                <Plus size={18} />
                Add another post-signup field
              </button>
            </div>
          </div>

          <textarea
            name="popupText"
            value={popupText}
            onChange={this.handleChange}
            placeholder="Popup Text"
            className="w-full p-2.5 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 text-sm sm:text-base"
            rows={4}
          />

          <button
            onClick={this.generateLink}
            disabled={this.state.loading}
            className="w-full bg-[var(--primary-color)] hover:opacity-75 text-white font-medium py-2.5 sm:py-3 px-6 rounded-lg disabled:opacity-75 transition-opacity text-sm sm:text-base"
          >
            {this.state.loading ? (
              <div className="flex items-center justify-center gap-2">
                <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin" />
                Saving...
              </div>
            ) : (
              "Save"
            )}
          </button>
          {generatedLink && (
            <div className="mt-4 p-3 bg-gray-50 rounded-lg border border-gray-200">
              <div className="flex flex-col sm:flex-row sm:items-start justify-between gap-3">
                <div className="flex-1">
                  <p className="text-sm font-medium text-gray-700 mb-1">
                    Generated Link:
                  </p>
                  <p className="text-blue-600 underline break-words text-xs sm:text-sm">
                    {generatedLink}
                  </p>
                </div>
                <button
                  onClick={this.handleCopy}
                  className="p-2 hover:bg-gray-100 rounded-full self-start"
                >
                  <div className="relative">
                    <Copy
                      size={18}
                      className={`transition-all ${
                        this.state.isCopied
                          ? "opacity-0 scale-90"
                          : "opacity-100 scale-100"
                      }`}
                    />
                    <Check
                      size={18}
                      className={`absolute top-0 left-0 text-green-500 transition-all ${
                        this.state.isCopied
                          ? "opacity-100 scale-100"
                          : "opacity-0 scale-90"
                      }`}
                    />
                  </div>
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }

  toggleRowExpand = (characterKey: string) => {
    this.setState((prevState) => ({
      expandedRows: {
        ...prevState.expandedRows,
        [characterKey]: !prevState.expandedRows[characterKey],
      },
    }));
  };

  handleSort = (column: any) => {
    console.log(column);
    this.setState((prevState) => {
      // If clicking the same column, toggle direction
      if (prevState.sorting.column === column) {
        return {
          sorting: {
            column,
            direction: prevState.sorting.direction === "asc" ? "desc" : "asc",
          },
          pageIndex: 0, // Reset to first page when sorting changes
        };
      }

      // If clicking a different column, set to ascending
      return {
        sorting: {
          column,
          direction: "asc",
        },
        pageIndex: 0,
      };
    });
  };

  handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      searchTerm: e.target.value,
      pageIndex: 0, // Reset to first page when search changes
    });
  };

  // Create a stable unique key for each character
  getCharacterKey = (char: any) => {
    // Use all UTM parameters to ensure uniqueness
    return `${char._id}`;
  };

  renderTable() {
    const {
      expandedRows,
      pageIndex,
      pageSize,
      sorting,
      charactersWithLinks,
      generatedLinks,
      searchTerm,
    } = this.state as any;
    const filteredData = charactersWithLinks.filter((char: any) => {
      if (!searchTerm) return true;

      const searchLower = searchTerm.toLowerCase();
      return (
        char.character_name.toLowerCase().includes(searchLower) ||
        char.utmSource.toLowerCase().includes(searchLower) ||
        char.utmMedium.toLowerCase().includes(searchLower) ||
        char.utmCampaign.toLowerCase().includes(searchLower) ||
        char.utmTerm.toLowerCase().includes(searchLower) ||
        char.utmContent.toLowerCase().includes(searchLower)
      );
    });

    // Enhance characters with links
    const data = filteredData.map((char: any) => ({
      ...char,
      links: generatedLinks[this.getCharacterKey(char)] || [],
    }));

    // Sort data
    const sortedData = [...data].sort((a: any, b: any) => {
      const aValue = a[sorting.column];
      const bValue = b[sorting.column];

      if (aValue < bValue) return sorting.direction === "asc" ? -1 : 1;
      if (aValue > bValue) return sorting.direction === "asc" ? 1 : -1;
      return 0;
    });

    const startIndex = pageIndex * pageSize;
    const currentPageData = sortedData.slice(startIndex, startIndex + pageSize);
    const pageCount = Math.ceil(data.length / pageSize);

    // Column headers configuration
    const columns: { id: any; label: string }[] = [
      { id: "createdAt", label: "Created At" },
      { id: "character_name", label: "Character Name" },
      { id: "utmSource", label: "UTM Source" },
      { id: "utmMedium", label: "UTM Medium" },
      { id: "utmCampaign", label: "UTM Campaign" },
      { id: "utmTerm", label: "UTM Term" },
      { id: "utmContent", label: "UTM Content" },
    ];

    // Total columns = data columns + actions column
    const totalColumns = columns.length + 1;

    return (
      <div className="lg:flex-[1_1_30%] bg-white p-4 rounded-lg shadow-md lg:max-h-[calc(100vh-100px)] overflow-y-auto">
        <div className="flex flex-row lg-flex-col justify-between">
          <h1 className="text-2xl sm:text-3xl font-bold text-gray-800">
            Generated Links
          </h1>

          <button
            onClick={this.resetForm}
            className="left-auto bg-white border border-gray-300 text-gray-800 text-sm font-medium py-2 px-3 rounded hover:bg-gray-100"
          >
            New UTM
          </button>
        </div>

        <div className="overflow-x-auto">
          <div className="relative w-full sm:w-64 my-4">
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
              <Search size={16} className="text-gray-400" />
            </div>
            <input
              type="text"
              placeholder="Search all fields..."
              className="block w-full pl-10 pr-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
              value={searchTerm}
              onChange={this.handleSearchChange}
            />
          </div>
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                {columns.map((col) => (
                  <th
                    key={col.id}
                    className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
                    onClick={() => this.handleSort(col.id)}
                  >
                    <div className="flex items-center">
                      {col.label}
                      {sorting.column === col.id &&
                        (sorting.direction === "asc" ? (
                          <ChevronUp size={14} className="ml-1" />
                        ) : (
                          <ChevronDown size={14} className="ml-1" />
                        ))}
                    </div>
                  </th>
                ))}
                <th className="px-3 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200">
              {currentPageData.map((char, index) => {
                const key = this.getCharacterKey(char);
                const isExpanded = expandedRows[key];

                return (
                  <React.Fragment key={key}>
                    <tr className="hover:bg-gray-50">
                      {/* Created At */}
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 max-w-[150px] truncate">
                        {new Date(char.createdAt).toDateString()}
                      </td>

                      {/* Character Name */}
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 max-w-[150px] truncate">
                        {char.character_name}
                      </td>

                      {/* UTM Columns */}
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 max-w-[120px] truncate">
                        {char.utmSource}
                      </td>
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 max-w-[120px] truncate">
                        {char.utmMedium}
                      </td>
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 max-w-[120px] truncate">
                        {char.utmCampaign}
                      </td>
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 max-w-[120px] truncate">
                        {char.utmTerm}
                      </td>
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 max-w-[120px] truncate">
                        {char.utmContent}
                      </td>

                      {/* Actions */}
                      <td className="px-3 py-3 whitespace-nowrap text-sm text-gray-800 text-right">
                        <button
                          onClick={() => this.selectCharacter(char, index)}
                          className={`inline-flex items-center px-3 py-1.5 bg-blue-500 hover:bg-blue-600 text-white text-sm font-medium rounded-md transition-colors focus:outline-none focus:ring-2 focus:ring-blue-300`}
                        >
                          <Edit size={16} color="#fff" className="mr-2" />
                          Link
                        </button>
                      </td>
                    </tr>
                    {isExpanded && char.links && char.links.length > 0 && (
                      <tr>
                        <td
                          colSpan={totalColumns}
                          className="px-3 py-3 bg-gray-50"
                        >
                          <div className="space-y-2">
                            <div className="text-xs font-medium text-gray-500 mb-1">
                              Generated Links:
                            </div>
                            {char.links.map((link: any, idx: any) => (
                              <div
                                key={idx}
                                className="flex items-center justify-between p-2 bg-white border rounded text-xs sm:text-sm break-words hover:bg-gray-100 cursor-pointer"
                                onClick={() =>
                                  navigator.clipboard.writeText(link)
                                }
                              >
                                <span className="flex-grow">{link}</span>
                                <Copy
                                  size={14}
                                  className="text-gray-500 ml-2 flex-shrink-0"
                                />
                              </div>
                            ))}
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        </div>

        {/* Pagination */}
        <div className="flex flex-wrap items-center justify-between mt-4 gap-2">
          <div className="flex flex-wrap gap-2">
            <button
              onClick={() => this.setState({ pageIndex: 0 })}
              disabled={pageIndex === 0}
              className="px-3 py-1 text-xs rounded border disabled:opacity-50"
            >
              First
            </button>
            <button
              onClick={() =>
                this.setState((prev) => ({
                  pageIndex: Math.max(prev.pageIndex - 1, 0),
                }))
              }
              disabled={pageIndex === 0}
              className="px-3 py-1 text-xs rounded border disabled:opacity-50"
            >
              Previous
            </button>
            <button
              onClick={() =>
                this.setState((prev) => ({
                  pageIndex: Math.min(prev.pageIndex + 1, pageCount - 1),
                }))
              }
              disabled={pageIndex >= pageCount - 1}
              className="px-3 py-1 text-xs rounded border disabled:opacity-50"
            >
              Next
            </button>
            <button
              onClick={() => this.setState({ pageIndex: pageCount - 1 })}
              disabled={pageIndex >= pageCount - 1}
              className="px-3 py-1 text-xs rounded border disabled:opacity-50"
            >
              Last
            </button>
          </div>

          <div className="flex flex-wrap items-center gap-4">
            <span className="text-sm whitespace-nowrap">
              Page <strong>{pageIndex + 1}</strong> of{" "}
              <strong>{pageCount}</strong>
            </span>
            <select
              value={pageSize}
              onChange={(e) => {
                this.setState({
                  pageSize: Number(e.target.value),
                  pageIndex: 0,
                });
              }}
              className="px-2 py-1 text-xs border rounded"
            >
              {[5, 10, 20].map((size) => (
                <option key={size} value={size}>
                  Show {size}
                </option>
              ))}
            </select>
          </div>
        </div>
      </div>
    );
  }
}

export default UTMForm;
